// extracted by mini-css-extract-plugin
module.exports = {"isBlock":"room__styles__isBlock___1mJlDk","isInline":"room__styles__isInline___2bCbDF"};